import React from 'react';

import { fg } from '@atlaskit/platform-feature-flags/fg';

import { LegacyAIProactiveNudge } from './LegacyAIProactiveNudge';

const LazyAIProactiveNudges = React.lazy(() =>
	import(
		/* webpackChunkName: "@atlaskit-internal_ai-proactive-nudges" */ './AIProactiveNudges'
	).then((module) => ({
		default: module.AIProactiveNudges,
	})),
);

type AIProactiveNudgeProps = {
	onActiveNudgeChange?: (hasActiveNudge: boolean) => void;
};

/**
 * Selects the proactive-nudge presentation controlled by
 * `confluence_rovo_agent_session_nudges`:
 * - disabled: the legacy pinned single-nudge flow;
 * - enabled: up to three independently-lived cards with immediate refill.
 */
export const AIProactiveNudge = ({ onActiveNudgeChange }: AIProactiveNudgeProps): JSX.Element => {
	if (fg('confluence_rovo_agent_session_nudges')) {
		return (
			<React.Suspense fallback={null}>
				<LazyAIProactiveNudges onActiveNudgeChange={onActiveNudgeChange} />
			</React.Suspense>
		);
	}

	return <LegacyAIProactiveNudge onActiveNudgeChange={onActiveNudgeChange} />;
};
